/* Barra fixa de compra no celular.
   So aparece na pagina de produto, so em tela pequena, e so depois que o
   botao original sai da vista. Se qualquer coisa faltar, nao faz nada. */
(function () {
  if (window.matchMedia && window.matchMedia('(min-width:750px)').matches) return;

  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  pronto(function () {
    var form = document.getElementById('mkpForm');
    var preco = document.getElementById('mkpPrice');
    var titulo = document.querySelector('.mkp__title');
    if (!form || !preco || !titulo) return;

    var botao = form.querySelector('button[type="submit"]');
    if (!botao) return;

    var barra = document.createElement('div');
    barra.className = 'mkbb';
    barra.innerHTML =
      '<span class="mkbb__info">' +
        '<span class="mkbb__n"></span>' +
        '<span class="mkbb__p"></span>' +
      '</span>' +
      '<button type="button" class="mkbb__b">Adicionar</button>';
    document.body.appendChild(barra);
    document.body.classList.add('mkbb-on');

    var nomeEl = barra.querySelector('.mkbb__n');
    var precoEl = barra.querySelector('.mkbb__p');
    nomeEl.textContent = titulo.textContent.trim();

    function sincronizar() { precoEl.textContent = preco.textContent.trim(); }
    sincronizar();

    /* o preco muda quando o cliente troca a cor */
    if ('MutationObserver' in window) {
      new MutationObserver(sincronizar).observe(preco, { childList: true, characterData: true, subtree: true });
    }

    barra.querySelector('.mkbb__b').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(botao);
      else botao.click();
    });

    /* mostra a barra so quando o botao original sai da tela */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        barra.classList.toggle('is-on', !e[0].isIntersecting);
      }, { threshold: 0 }).observe(botao);
    } else {
      barra.classList.add('is-on');
    }
  });
})();
